/**
 * Created by greg on 9/03/2018.
 */

// Default Event object
/*export interface EventObject {
    object: 'list' | 'charge' | 'customer' | 'source' | 'subscription';
    [key: string]: any
}*/
// PurchaseTransaction
import {firestore} from 'firebase';


export interface PurchaseTransaction {
    type: string; // free | one_off | bulk5 | bulk10 | subscription
    uid?: string;
    // just guessing what this will need
    customerId?: string;
    transactionId?: string;
}

// EventHelp
export interface EventHelpDetails {
    name:string;
    email:string;
    phone:string;
}

// Products
export interface Product {
    plan:string,
    quantity:number,
    frequency:string, // 'Monthly'
    rate:number,
    label:string,
    type:string // "subscription"
}

// Tiers
export interface Tier {
    amount:number,
    up_to?:number
}

// Plans
export interface Plan {
    id:string,
    currency:string,
    nickname:string,
    interval:string, // 'Monthly'
    billing_scheme:string // "tiered"
    tiers?:Array<Tier>
}

// Stats
export class Stats {
    loaded?:boolean;
    list_count:number = 0;
    invited:number = 0;
    accepted:number = 0;
    declined:number = 0;
    attended:number = 0;
    attending:number = 0;
    unanswered:number = 0;
    not_yet_invited:number = 0;
    walk_ins:number = 0;
    checkedIn: number = 0;
}

// Email
export class Email {
    eventId?: string;
    accountId?: string;
    logo: string;
    body: string;
    sender: string;
    subject: string;
    sent?: Array<number>;
    count?: number;
    bounced?: number;
    open?: number;
}

// Emails
// export interface Emails {
//     invite:Email;
//     ticket:Email;
// }

// CheckitEvent
export class CheckitEvent {
    eventId?: string;
    accountId: string;
    created?: Date;
    title?: string;
    date?: Date;
    start?: string;
    end?: string;
    is_new?: boolean;
    is_duplicate?: boolean;
    retain_unique_ids?: boolean;
    venue?:string;
    venue_url?:string;
    address?: string;
    help?:EventHelpDetails;
    invitationMail?: Email;
    ticketMail?: Email;
    emailMail?: Email;
    token?: string;
    users?: any;
    use_custom_id?:boolean;
    totalCheckin: number;
    inviteSent: number;
    ticketSent: number;
    closed?: boolean;

    constructor(eventId){
        this.eventId = eventId;
    }
}

export class Registrant {
    registrantId: string;
    email: string;
    firstName: string;
    lastName: string;
    company: string;
    phone: string;
    eventId: string;
    attending: string;
    walkin: boolean;
    method: string;
    created: Date;
    createdBy: string;
    scanId: string;
    inviteSent: number;
    ticketSent: number;
    checkedIn: number;
    attendingResponse: number;
    send_invitation?: boolean;
    send_ticket?: boolean;
    send_email?: boolean;
    show_detail?:boolean;
}




// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/checkit.model.ts